import React from "react";
// COMPONENTS
import SitePageShell from "Components/WebsiteTheme/SitePageShell";
import SiteSectionHead from "Components/WebsiteTheme/SiteSectionHead";
import SiteCtaBand from "Components/WebsiteTheme/SiteCtaBand";
import PageHeading from "Components/PageHeading/PageHeading";
import { IconQuote } from "Components/WebsiteTheme/SiteIcons";
import { revealProps } from "Components/WebsiteTheme/Reveal";
import { DEMO_BAND } from "Components/WebsiteTheme/site.data";
// STYLES
import { TestimonialsPageContainer } from "./Testimonials.style";

export const testimonials = [
	{
		name: "Heather Lehigh",
		role: `EHS - Department Chair Social Sciences`,
		content:
			"My seniors really love Subjects Masters! Because I can customize the Econ and Government questions, the students share how helpful it is to review before quizzes. The different games create a variety of interaction to keep students stimulated and challenged. It is wonderful to have an application that responds to a teacher's need while motivating students to study! Looking forward to finding new ways to incorporate Subjects Master in my classroom and sharing this website with my fellow teachers. ",
	},
	{
		name: "Ryon Everidge",
		role: "After School Tutor",
		content:
			"I really enjoyed subjects masters. The games provide an amazing learning experience I wish I had when I was in school. Subjects Masters makes me want to learn more. The website has a great mix of games and learning. I believe that if anyone student utilized this website their test scores and grades would increase dramatically. The gaming format providing makes it easy to retain the information.",
	},
];

/** Initials for the avatar (no stock face stands in for a real teacher, same as Home and About). */
const initials = (name) =>
	name
		.split(" ")
		.map((part) => part[0])
		.join("")
		.slice(0, 2)
		.toUpperCase();

/** Testimonials page, in the Home and About page style (heading, cream quote cards, closing band). */
const TestimonialsPage = () => (
	<SitePageShell className="testimonials_page">
		<PageHeading
			tone="site"
			title={<>Testimonials</>}
			breadcrumbs={[
				{ label: "Home", path: "/" },
				{ label: "Testimonials" },
			]}
		/>

		<TestimonialsPageContainer className="sm_section">
			<div className="sm_container">
				<SiteSectionHead
					eyebrow="Testimonials"
					title={
						<>
							Hear from <span className="sm_accent">Our Teachers</span>
						</>
					}
					lead="Our community of educators and families inspires us every day. Hear how Subjects Master is helping students stay motivated, teachers save time, and parents feel confident about their child’s learning journey."
					{...revealProps("up")}
				/>

				<ul className="tp_grid">
					{testimonials.map((item, index) => (
						<li key={item.name} className="tp_card" {...revealProps("up", index + 1)}>
							<span className="tp_mark" aria-hidden="true">
								<IconQuote />
							</span>
							<blockquote className="tp_quote">{item.content.trim()}</blockquote>
							<div className="tp_author">
								<span className="tp_avatar" aria-hidden="true">
									{initials(item.name)}
								</span>
								<div>
									<p className="tp_name">{item.name}</p>
									<p className="sm_caption">{item.role}</p>
								</div>
							</div>
						</li>
					))}
				</ul>
			</div>
		</TestimonialsPageContainer>

		<SiteCtaBand title={DEMO_BAND.title} text={DEMO_BAND.text} />
	</SitePageShell>
);

export default TestimonialsPage;
